import { getTabs } from "modules/tokens/selectors"
import type { ReduxState } from "model/state"
import createModule from "../createModule"
import view from "./view"

// No `data` descriptor: the members-and-tokens payload comes from `useAccountPats()`
// (react-query), not the legacy resource loader. The account never has to reach the view as a
// prop either — the hook reads it with `useAccountAlias()` and gates its own fetch on it.
export default createModule({
  view,
  // The same selector Members and Tokens use, so the four tabs of this set agree on which one
  // is selected and where each points.
  mapStateToProps: (state: ReduxState, props: object) => ({
    tabs: getTabs(state, props),
  }),
})
